var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7364 13.4912L8.7422 7.50034L14.7364 1.55357C15.0368 1.20565 15.0205 0.683539 14.699 0.355259C14.3776 0.0269787 13.8593 0.00320055 13.5095 0.300685L7.49779 6.20335L1.59126 0.25657C1.24945 -0.0855232 0.697423 -0.0855232 0.355618 0.25657C0.189715 0.422238 0.0963975 0.647753 0.0963975 0.88301C0.0963975 1.11827 0.189715 1.34378 0.355618 1.50945L6.25339 7.4474L0.25922 13.3854C0.0933177 13.551 0 13.7765 0 14.0118C0 14.2471 0.0933177 14.4726 0.25922 14.6382C0.424602 14.8034 0.648488 14.8955 0.881422 14.8941C1.11008 14.8955 1.33023 14.8068 1.49486 14.6471L7.49779 8.69146L13.5095 14.7441C13.6749 14.9093 13.8988 15.0013 14.1317 15C14.3616 14.999 14.5819 14.9071 14.7451 14.7441C14.9099 14.5773 15.0016 14.3511 15 14.1158C14.9983 13.8806 14.9034 13.6557 14.7364 13.4912Z",
    fill: "#1E1E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseBtn);
export default __webpack_public_path__ + "static/media/ic-close-btn.981eb00ce87d8c82de27f7e0d11cb11d.svg";
export { ForwardRef as ReactComponent };